import { render, staticRenderFns } from "./Component-RescueTeam.vue?vue&type=template&id=64c79f4a&"
import script from "./Component-RescueTeam.vue?vue&type=script&lang=js&"
export * from "./Component-RescueTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports